interface RoundedCardProps {
  name?: string;
}

const Rounded: React.FC<RoundedCardProps> = ({ name }) => (
  <div className='bg-[#252740] inline-flex pt-1 pb-1 pr-3 pl-3 rounded-[13px] items-center justify-center'>
    <p className='text-[#ffffff] text-sm font-medium'>{name}</p>
  </div>
);
export default Rounded;
